var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{attrs:{"gutter":20}},[_c('Col',{attrs:{"span":12}},[_c('Card',[_c('div',{attrs:{"id":"statusConsist"}})])],1),_c('Col',{attrs:{"span":12}},[_c('Card',[_c('div',{attrs:{"id":"randomStatusConsist"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }